<script lang="ts">
import { defineComponent, defineAsyncComponent } from 'vue';
import SiteHeader from 'components/Base/SiteHeader.vue';
import UserNavigation from 'components/User/Navigation.vue';
import { PageStore } from 'stores/Page/Page.ts';
import { useMeta } from 'quasar';

export default defineComponent({
  name: 'UserLayout',

  inject: ['isLogged'],

  async preFetch({ store, currentRoute }) {
    const pageStore = PageStore(store);
    const [, first, second] = currentRoute.path.split('/');
    await pageStore.getPage(first, second ? { section: second } : {});
  },

  setup() {
    useMeta({
      titleTemplate: (title) => `${title} | Kullanıcı İşlemleri`,
    });
  },

  components: { 
    UserNavigation, 
    SiteHeader, 
    SiteFooter: defineAsyncComponent(() => import('components/Base/SiteFooter.vue'))
  },

  mounted() {
    if (!this.isLogged) {
      window.location.replace('/login-or-register');
    }
  },
});
</script>

<template>
  <q-layout id="page" class="site">
    <site-header />

    <q-page-container id="content" class="site-content">
      <user-navigation class="q-my-xl">
        <router-view />
      </user-navigation>
    </q-page-container>

    <site-footer />
  </q-layout>
</template>

<style scoped></style>
